import { useFormikContext } from 'formik';
import { get, map, uniq } from 'lodash';
import { useMemo } from 'react';

import { useJobContext } from 'hb-react/shared/apps/JobForm/contexts/JobContext';
import { Col } from 'hb-react/shared/components/DesignSystem/Grid';
import { SelectArray } from 'hb-react/shared/components/formik/components/inputs';

import { MODE } from '../constants';
import { type FormValues, type ModeValues } from '../types';

export const Topics = ({ mode }: { mode: ModeValues }) => {
  const { setFieldValue, values } = useFormikContext<FormValues>();

  const { topics = [] } = useJobContext();

  const value = useMemo(
    () => map(values.topics, (input) => get(input, 'value', input)),
    [values.topics],
  );

  if (mode === MODE.BO && topics.length) {
    const handleChange = (input) => {
      if (values.parent_id && values.parent_type === 'Topics::Topic') {
        input.unshift(topics.find(({ value }) => value === values.parent_id));
      }

      setFieldValue('topics', uniq(input));
      setFieldValue('topic_ids', uniq(input.map(({ value }) => value)));
    };

    return (
      <Col width={{ _: 1, m: 0.5 }}>
        <SelectArray
          label={s__('JobForm|Related groups')}
          multiple
          name="topics"
          onChange={handleChange}
          options={topics}
          value={value}
        />
      </Col>
    );
  }

  return null;
};
